"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { loadVWO } from "@/utils/vwoUtils";
import { scheduleIdleTask } from "@/utils/scheduleIdleTask";

export default function VwoActivateOnRouteChange() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = searchParams?.toString()
      ? `${pathname}?${searchParams.toString()}`
      : pathname;

    return scheduleIdleTask(() => {
      loadVWO(url);
    });
  }, [pathname, searchParams]);

  return null;
}
